export default {
  setClient(state, clientData) {
    state.clientID = clientData.clientID;
    state.walletID = clientData.walletID;
    state.firstName = clientData.firstName;
    state.lastName = clientData.lastName;
    state.balance = clientData.balance;
    state.isOverseas = clientData.isOverseas;
    state.email = clientData.email;
    state.clientCode = clientData.clientCode;
    state.phone = clientData.phone;
    state.clientList = clientData.clientList;
  },
  setBalance(state, balance) {
    state.balance = balance;
  },
  setClientList(state, clientData) {
    state.clientList = clientData;
  },
  setWorkshopFilter(state, workshopSearchModel) {
    state.workshopSearchModel = workshopSearchModel;
  },
  setCurrentPanel(state, currentPanel) {
    state.currentPanel = currentPanel;
  },
};
